import script from "./InputField.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputField.vue?vue&type=script&setup=true&lang=ts"

import "./InputField.vue?vue&type=style&index=0&id=71648784&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71648784"]])

export default __exports__